const constants = Object.freeze({
  STEPS: 3,
  PLATE_NUMBER_MINLENGTH: 2,
  VEHICLE_DURATION: 1,
  PAYMENT_PROVIDER_VALITOR: 'valitor-pay',
  PAYMENT_PROVIDER_VERIFONE: 'verifone',
  LOCATION_THINGVELLIR: 'THINGVELLIR',
  LOCATION_SELIR: 'SELIR',
  LOCATION_SELJALANDSFOSS: 'SELJALANDSFOSS',
  LOCATION_HENGIFOSS: 'HENGIFOSS',
});

export default constants;
